export const ApplicantListfloatingMenuOptions = {
  inline: [
    {
      icon: "ApplicantDeleteIcon",
      label: "Delete",
      action: "delete",
    },
    {
      icon: "SendSMS",
      label: "Send SMS",
      action: "sendSMS",
    },
    {
      icon: "AddToProject",
      label: "Add To Project",
      action: "addToProject",
    },
  ],
  menuOptions: [
    {
      label: "Upload Resume",
      action: "newApplicants",
    },
    {
      label: "Upload Excel",
      action: "uploadExcel",
    },
    {
      label: "Create Manually",
      action: "createManually",
    },
  ],
};

export const PostingListfloatingMenuOptions = {
  inline: [
    {
      icon: "ApplicantDeleteIcon",
      label: "Delete",
      action: "delete",
    },
    {
      icon: "Clone",
      label: "Clone",
      action: "clone",
    },
  ],
  menuOptions: [
    {
      label: "Upload JD",
      action: "uploadJd",
    },
    {
      label: "Create Manually",
      action: "createManually",
    },
  ],
};

export const ApplicantTablefloatingMenuOptions = {
  inline: [
    {
      icon: "ApplicantDeleteIcon",
      label: "Delete",
      action: "confirmDel",
    },
    {
      icon: "SendSMS",
      label: "Send SMS",
      action: "Send SMS",
    },
    {
      icon: "AddToProject",
      label: "Add To Project",
      action: "Add to Project",
    },
  ],
  menuOptions: [
    {
      label: "Upload Resume",
      action: "newApplicants",
    },
    {
      label: "Upload Excel",
      action: "uploadExcel",
    },
    {
      label: "Create Manually",
      action: "createManually",
    },
  ],
};

export const ApplicantsDetailsTabsfloatingMenuOptions = {
  inline: [
    {
      icon: "ApplicantMailIcon",
      label: "Email Candidate",
      action: "Send E-mail",
    },
    {
      icon: "ApplicantEditIcon",
      label: "Edit Profile",
      action: "edit",
    },
  ],
  menuOptions: [],
};

export const JobpostingDetailsMenuOptions = {
  inline: [
    {
      icon: "ApplicantDeleteIcon",
      label: "Delete",
      action: "delete",
    },
    {
      icon: "Clone",
      label: "Clone",
      action: "clone",
    },
    {
      icon: "ApplicantEditIcon",
      label: "Edit",
      action: "edit",
    },
  ],
};

export const AssociateAppliantMenuOptions = {
  menuOptions: [
    {
      label: "Associate Applicants",
      action: "Add Associate Applicants",
    },
    {
      label: "Delete",
      action: "Delete",
    },
    {
      label: "Send E-mail",
      action: "Send E-mail",
    },
    {
      label: "Update Status",
      action: "Update Status",
    },
  ],
};

export const AssociateAppliantPendingMenuOptions = {
  menuOptions: [
    {
      label: "Accept",
      action: "Accept",
    },
    {
      label: "Reject",
      action: "Reject",
    },
  ],
};

export const ClientListfloatingMenuOptions = {
  inline: [
    {
      icon: "ApplicantDeleteIcon",
      label: "Delete",
      action: "delete",
    },
    {
      icon: "ApplicantEditIcon",
      label: "Edit",
      action: "edit",
    },
  ],
};

export const ProjectViewfloatingMenuOptions = {
  inline: [
    {
      icon: "ApplicantEditIcon",
      label: "Edit",
      action: "edit",
    },
  ],
};

export const AssociatedApplicantsfloatingMenuOptions = {
  menuOptions: [
    {
      label: "Send Email",
      action: "sendEmail",
    },
    {
      label: "Send SMS",
      action: "sendSMS",
    },
    {
      label: "Delete",
      action: "delete",
    },
  ],
};

export const ReportCentrefloatingMenuOptions = {
  menuOptions: [
    {
      label: "Schedule Report",
      action: "scheduleReport",
    },
    {
      label: "Instant Reports",
      action: "instantReports",
    }
  ]
};

export const JobsAddfloatingMenuOptions = {
  menuOptions: [
    {
      label: "Add Jobs",
      action: "addJobs",
    },
    {
      label: "Delete",
      action: "delete",
    }
  ],
};